import React, { Dispatch, SetStateAction, useState } from "react";
import {useTranslation} from "react-i18next";
import Select from "@awsui/components-react/select";
import User from "model/User";
import { useQuery } from "react-query";
import getUsers from "api/getUsers";
import Flashbar from "@awsui/components-react/flashbar";
import Spinner from "@awsui/components-react/spinner";
import { OptionDefinition } from "@awsui/components-react/internal/components/option/interfaces";
import {useAuth} from "hooks/useAuth";


interface UsersSelectProps {
    selectedUser: User | undefined;
    setSelectedUser: Dispatch<SetStateAction<User | undefined>>;
    leagueId: number;
}

const UsersSelect: React.FC<UsersSelectProps> = (props) => {

    const {t} = useTranslation(["common", "errors"]);
    const [{user}] = useAuth();
    const [selectedOption, setSelectedOption] = useState({});

    const {
        isLoading: usersIsLoading,
        data: users,
        error: getUsersError
    } = useQuery<User[], Error>("getUsers", () => getUsers(props.leagueId, user?.token));

    const changeUser = (selected: OptionDefinition, users: User[]) => {
        setSelectedOption(selected);
        const selectedUser: User = users?.filter(user => (
            user.uid === selected.value
        ))[0];
        props.setSelectedUser(selectedUser);
    };

    if (getUsersError) {
        return (
            <Flashbar
                items={[{
                    header: t("errors:usersLoad"),
                    type: "error",
                    content: t("common:errors.tryReload"),
                    dismissible: false,
                }]}
            />
        );
    }

    if (usersIsLoading || selectedOption === undefined) {
        return (
            <Spinner size="big" />
        );
    }

    return (
        <Select
            selectedOption={selectedOption}
            onChange={({ detail }) => (
                changeUser(detail.selectedOption, users || [])
            )}
            options={users?.map(user => ({
                label: `${user.name} (${user.email})`,
                value: user.uid
            }))}
            selectedAriaLabel={t("common:common.selected")}
        />
    );
};

export default UsersSelect;
